import { Directive, effect, ElementRef, Input, NgZone, OnInit, signal } from '@angular/core';

@Directive({
    selector: '[copyOnClick]',
    exportAs: 'copyDirective',
    standalone: true
})
export class CopyOnClickDirective implements OnInit {
    @Input('copyOnClick') text!: string;
    showTooltip = signal(false);

    constructor(
        private host: ElementRef<HTMLElement>,
        private ngZone: NgZone,
    ) {

        effect(() => {
            if (this.showTooltip()) {
                setTimeout(() => this.showTooltip.set(false), 1000);
            }
        })
    }

    ngOnInit(): void {
        this.ngZone.runOutsideAngular(() => {
            this.host.nativeElement.addEventListener('click', () => {
                this.copyToClipboard();
            });
        });
    }

    private copyToClipboard(): void {
        const el = document.createElement('textarea');
        el.value = this.text;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.showTooltip.set(true);
    }


}
